import React from 'react';
import { usePasswordStep } from './usePasswordStep';
import { AuthPasswordStepView } from './AuthPasswordStepView';

type AuthPasswordStepProps = {
    loading?: boolean;
    onPasswordSubmit: (password: string) => void;
    error?: string | null;
    dismissError?: () => void;
};

export const AuthPasswordStep: React.FC<AuthPasswordStepProps> = ({
    loading,
    onPasswordSubmit,
    error,
    dismissError,
}) => {
    const {
        register,
        errors,
        showPassword,
        toggleShowPassword,
        onSubmit,
    } = usePasswordStep(onPasswordSubmit);
    return (
        <AuthPasswordStepView
            register={register}
            errors={errors}
            loading={loading}
            showPassword={showPassword}
            error={error}
            dismissError={dismissError}
            onToggleShowPassword={toggleShowPassword}
            onSubmit={onSubmit}
        />
    );
};
